import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ViewEditDelete from './components/ViewEditDelete.vue';

const app = createApp(App);

app.component('ViewEditDelete', ViewEditDelete)

app.use(store).use(router).mount('#app');
